<template>
  <div class="slip-page">
    <h3 class="page-title">{{ $t("transaction.transactions") }}</h3>

    <div class="type-tabs">
      <button
        type="button"
        class="type-chip"
        :class="{ active: transactionType === 'all' }"
        @click="fetchHistory('all')"
      >
        {{ $t("transaction.all") }}
      </button>
      <button
        type="button"
        class="type-chip"
        :class="{ active: transactionType === 'in' }"
        @click="fetchHistory('in')"
      >
        {{ $t("transaction.deposit") }}
      </button>
      <button
        type="button"
        class="type-chip"
        :class="{ active: transactionType === 'out' }"
        @click="fetchHistory('out')"
      >
        {{ $t("transaction.withdraw") }}
      </button>
    </div>

    <section class="filter-card">
      <div class="filter-row">
        <div class="select-wrap">
          <v-select
            v-model="params.date"
            :reduce="(draw) => draw.data"
            label="label"
            :options="dateOptions"
          ></v-select>
        </div>
        <button
          type="button"
          class="search-btn"
          @click="fetchHistory(transactionType)"
        >
          {{ $t("transaction.search") }}
        </button>
      </div>
    </section>

    <section class="list-card">
      <div class="loading-wrap" v-if="isLoading">
        <Loading color="#e7b534" size="24" class="px-4 py-0" />
        <span>{{ $t("please_wait") }}</span>
      </div>
      <DataTable
        v-if="!isLoading"
        :tableData="tableData"
        @getSlipData="fetchSlipData"
      />
      <van-pagination
        v-model="currentPage"
        :total-items="rows"
        :items-per-page="10"
        :show-page-size="3"
        size="sm"
        force-ellipses
      >
        <template #prev-text>
          <van-icon name="arrow-left" />
        </template>
        <template #next-text>
          <van-icon name="arrow" />
        </template>
        <template #page="{ text }">{{ text }}</template>
      </van-pagination>
    </section>

    <div class="col-4">
      <div
        class="modal fade"
        id="voucher-history"
        tabindex="-1"
        role="dialog"
        aria-labelledby="modal-form"
        aria-hidden="true"
      >
        <div class="modal-dialog modal- modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="text-center modal-cross" @click="closeModal">X</div>
            <div class="modal-body p-0">
              <FBVoucher
                :type="type"
                :datas="datas"
                :slipId="slipId"
                :currentTime="bet_date"
                :isHistory="true"
                :is_result="is_result"
                :bingo_amount="bingo_amount"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import SideNav from './components/SideNav.vue';
import { DateTime } from "luxon";
import { Loading } from "vant";
import DataTable from "./components/DataTable.vue";
import FBVoucher from "./components/FBVoucher.vue";
import { mapActions } from "vuex";

export default {
  components: { DataTable, FBVoucher, Loading },
  data() {
    return {
      tableData: {
        headings: [
          this.$t("voucher.total_amount"),
          this.$t("transaction.balance"),
          this.$t("transaction.type"),
          this.$t("transaction.status"),
          this.$t("transaction.action_by"),
          this.$t("voucher.bet_date"),
        ],
        datas: [],
      },
      rows: 1,
      currentPage: 1,
      depositActive: false,
      withdrawActive: false,
      transactionType: "all",
      params: {
        draw: "",
        date: "",
      },
      dateOptions: [],
      type: "maung",
      datas: [],
      slipId: null,
      bet_date: null,
      bingo_amount: null,
      is_result: false,
      isLoading: false,
    };
  },
  methods: {
    ...mapActions(["fetchUser"]),
    setOneMonth() {
      for (let i = 0; i < 30; i += 1) {
        const d = new Date();
        d.setHours(23, 59, 59);
        d.setDate(d.getDate() - i);
        const newObject = {};
        newObject.label = moment(d).format("l");
        newObject.data = d;
        this.dateOptions.push(newObject);
      }
    },
    closeModal() {
      $("#voucher-history").modal("hide");
    },
    fetchSlipData(data) {
      this.type = data.type;
      this.datas = data.team_vouchers;
      this.bingo_amount = data.bingo_amount;
      this.slipId = data.voucher_id;
      this.is_result = data.isBet;
      this.bet_date = this.betTime(data.created_at);
      $("#voucher-history").modal("show");
    },
    betTime(time) {
      const newTime = new Date(time);
      const targetTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const myanmarDateTime = DateTime.fromJSDate(newTime);
      const targetDateTime = myanmarDateTime.setZone(targetTimeZone);
      const adjustedDrawDate = new Date(targetDateTime.toISO()).toLocaleString(
        "en-US",
        { timeZone: targetTimeZone }
      );
      return moment(adjustedDrawDate).format("lll");
    },
    async fetchHistory(type = "all") {
      try {
        this.transactionType = type;
        // this.depositActive = true;
        // this.withdrawActive = false;
        this.isLoading = true;
        this.tableData.contents = [
          "amount",
          "current_amount",
          "type",
          "status",
          "by_user_name",
          "created_at",
        ];
        const res = await axios.post(
          "/transactions/get_by_solo",
          {
            //   params: {
            page: this.currentPage,
            limit: 10,
            user_id: this.$store.state.authUser.id,
            drawDate: this.params.date,
            type,
            //   },
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
        this.tableData.datas = res.data.data;
        for (let index = 0; index < this.tableData.datas.length; index += 1) {
          this.tableData.datas[index].created_at = this.betTime(
            this.tableData.datas[index].created_at
          );
          this.tableData.datas[index].amount = Number(
            this.tableData.datas[index].amount
          ).toLocaleString();
          this.tableData.datas[index].current_amount = Number(
            this.tableData.datas[index].current_amount
          ).toLocaleString();
        }
        this.isLoading = false;
        this.rows = res.data.total;
      } catch (error) {
        console.log(error);
      }
    },
    // async fetchWithdrawHistory() {
    //   try {
    //     this.depositActive = false;
    //     this.withdrawActive = true;
    //     this.tableData.contents = ['date', 'type', 'amount', 'status'];
    //     const res = await axios.get('/withdraws', {
    //       params: {
    //         page: this.currentPage,
    //         limit: 1,
    //       },
    //     });
    //     this.tableData.datas = res.data.data;
    //     this.rows = res.data.total;
    //   } catch (error) {
    //     console.log(error);
    //   }
    // },
  },
  watch: {
    currentPage() {
      this.fetchHistory(this.transactionType);
    },
  },
  async mounted() {
    const authUser = await this.fetchUser();
    if (!authUser) {
      this.$router.push("/auth/login");
    }
    this.params.date = moment(new Date()).format("l");
    this.fetchHistory();
    this.setOneMonth();
  },
};
</script>
<style scoped>
.slip-page {
  min-height: 100vh;
  padding: 14px 14px 8rem;
}
.page-title {
  margin-bottom: 12px;
  color: #f0e6c8;
  font-weight: 700;
}
.type-tabs {
  display: flex;
  gap: 8px;
  overflow-x: auto;
  margin-bottom: 12px;
}
.type-chip {
  flex: 1;
  min-width: 0;
  height: 2.4rem;
  border: 0;
  border-radius: 10px;
  background: #2a2a2a;
  color: #f0e6c8;
  font-size: 0.82rem;
  font-weight: 700;
  white-space: nowrap;
  cursor: pointer;
}
.type-chip.active {
  background: linear-gradient(180deg, #f7d56a, #e7b534);
  color: #1a1408;
}
.filter-card,
.list-card {
  background: #1c1c1c;
  border-radius: 14px;
  padding: 12px;
  margin-bottom: 12px;
}
.filter-row {
  display: flex;
  align-items: center;
  gap: 8px;
}
.select-wrap {
  flex: 1;
  min-width: 0;
}
.search-btn {
  flex-shrink: 0;
  height: 2.4rem;
  padding: 0 16px;
  border: 0;
  border-radius: 10px;
  background: linear-gradient(180deg, #f7d56a, #e7b534);
  color: #1a1408;
  font-weight: 700;
  cursor: pointer;
}
.loading-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 3rem 1rem;
  color: #d8c48a;
}
.modal-cross {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  padding-top: 3px;
  margin-left: auto;
  color: white;
  cursor: pointer;
  margin-right: -9px;
  margin-top: -9px;
  background: rgb(228, 87, 87);
}
</style>
